import { useQuery } from 'react-query'
import { getAuditLogs, AuditLogParams } from 'services/cm-api/get-audit-logs'

export function useAuditLogs(
  customerId: number | string,
  params: AuditLogParams = {},
  enabled: boolean = true,
) {
  return useQuery(
    ['auditLogs', customerId, params],
    () => getAuditLogs(customerId, params),
    {
      keepPreviousData: true,
      staleTime: 30000,
      enabled: !!customerId && enabled,
    },
  )
}
